import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';

export const learning: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('admin-tabs.program-management') as string;
			},
		},
		path: 'learning',
		name: Routes.GROUP_ADMIN_LEARNING_PROGRAMS,
		redirect: { name: Routes.GROUP_ADMIN_LEARNING_PROGRAMS_ALL_PROGRAMS },
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				groupId: route.params.groupId,
			};
		},
		component: () => import(
			/* webpackChunkName: "group-admin-lms" */
			'@front-app/views/home/group/admin/LearningProgramsMain.vue'
		),
		children: [
			{
				meta: {
					title(i18n: VueI18n): string {
						// TODO: Add group title here as well, somehow
						return i18n.t('lms.admin.all-programs') as string;
					},
				},
				path: 'programs',
				name: Routes.GROUP_ADMIN_LEARNING_PROGRAMS_ALL_PROGRAMS,
				redirect: { name: Routes.GROUP_ADMIN_LEARNING_PROGRAMS_LIST },
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				props(route: Route): any {
					return {
						groupId: route.params.groupId,
					};
				},
				component: () => import(
					/* webpackChunkName: "group-admin-lms-list" */
					'@front-app/views/home/group/admin/learningPrograms/LearningPrograms.vue'
				),
				children: [
					{
						meta: {
							title(i18n: VueI18n): string {
								// TODO: Add group title here as well, somehow
								return i18n.t('all.all') as string;
							},
						},
						path: 'list',
						name: Routes.GROUP_ADMIN_LEARNING_PROGRAMS_LIST,
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
						props(route: Route): any {
							return {
								groupId: route.params.groupId,
							};
						},
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// @ts-ignore
						component: () => import(
							/* webpackChunkName: "group-admin-learning-programs-all" */
							'@front-app/views/home/group/admin/learningPrograms/AllPrograms.vue'
						),
					},
					{
						meta: {
							title(i18n: VueI18n): string {
								// TODO: Add group title here as well, somehow
								return i18n.t('admin-tabs.program-management') as string;
							},
						},
						path: ':programId',
						name: Routes.GROUP_ADMIN_MANAGE_LEARNING_PROGRAM,
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
						props(route: Route): any {
							return {
								groupId: route.params.groupId,
								programId: route.params.programId,
							};
						},
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// @ts-ignore
						component: () => import(
							/* webpackChunkName: "group-admin-lms-single" */
							'@front-app/views/home/group/admin/learningPrograms/LearningProgram.vue'
						),
					},
				],
			},
			{
				meta: {
					title(i18n: VueI18n): string {
						// TODO: Add group title here as well, somehow
						return i18n.t('lms.admin.manage-surveys') as string;
					},
				},
				path: 'surveys',
				name: Routes.GROUP_ADMIN_LEARNING_PROGRAMS_MANAGE_SURVEYS,
				redirect: { name: Routes.GROUP_ADMIN_SURVEY_MANAGEMENT_LIST },
				component: () => import(
					/* webpackChunkName: "group-admin-lms" */
					'@front-app/views/home/group/admin/surveys/SurveyManagement.vue'
				),
				children: [
					{
						meta: {
							title(i18n: VueI18n): string {
								return i18n.t('page.title.survey-management') as string;
							},
						},
						path: '',
						name: Routes.GROUP_ADMIN_SURVEY_MANAGEMENT_LIST,
						component: () => import(
							/* webpackChunkName: "group-admin-lms" */
							'@front-app/views/home/group/admin/surveys/SurveyManagementList.vue'
						),
					},
					{
						meta: {
							title(i18n: VueI18n): string {
								return i18n.t('page.title.create-survey') as string;
							},
						},
						path: 'create',
						name: Routes.GROUP_ADMIN_SURVEY_CREATE,
						component: () => import(
							/* webpackChunkName: "group-admin-lms" */
							'@front-app/views/home/group/admin/surveys/SurveyCreate.vue'
						),
					},
					{
						meta: {
							title(i18n: VueI18n): string {
								return i18n.t('page.title.edit-survey') as string;
							},
						},
						path: 'edit/:surveyId',
						name: Routes.GROUP_ADMIN_SURVEY_EDIT,
						component: () => import(
							/* webpackChunkName: "group-admin-lms" */
							'@front-app/views/home/group/admin/surveys/SurveyEdit.vue'
						),
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
						props(route: Route): any {
							return {
								surveyId: route.params.surveyId,
							};
						},
					},
					{
						meta: {
							title(i18n: VueI18n): string {
								return i18n.t('lms.admin.survey-responses') as string;
							},
						},
						path: 'responses/:surveyId',
						name: Routes.GROUP_ADMIN_SURVEY_RESPONSES,
						component: () => import(
							/* webpackChunkName: "group-admin-lms" */
							'@front-app/views/home/group/admin/surveys/SurveyResponses.vue'
						),
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
						props(route: Route): any {
							return {
								surveyId: route.params.surveyId,
							};
						},
					},
				],
			},
		],
	},
];
